import {Parallax} from '../components';
import {VueMailchimpEmailSignupForm} from "vue-mailchimp-email-signup-form";

/**
 * You can register global components here
 */

const globalComponents = {
	install(Vue) {
		Vue.component(Parallax.name, Parallax);
		Vue.component("vue-mailchimp-email-signup-form", VueMailchimpEmailSignupForm);
	}
};

export default globalComponents;
